import React from 'react';
import { processSteps } from '../data/process';
import { Reveal } from './Reveal';
export function ApproachSection() {
  return <section aria-labelledby="approach-heading" className="bg-white py-24 lg:py-32" data-id="element-29" data-mp="25zd0851swkjh">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-30" data-mp="1rz24oopjqhrz">
        <Reveal className="max-w-2xl" data-id="element-31" data-mp="1wx3rnkq3f18q">
          <span className="block h-px w-12 bg-gold" aria-hidden="true" data-id="element-32" data-mp="1wy6ijsnf13on" />
          <h2 id="approach-heading" className="mt-6 font-serif text-4xl font-medium leading-[1.1] text-navy sm:text-5xl" data-id="element-33" data-mp="2km65ehhlw9xy">
            A considered recruitment process, from brief to introduction.
          </h2>
        </Reveal>

        <ol className="mt-16 grid lg:mt-20 lg:grid-cols-4" data-id="element-34" data-mp="2ausa6lwotwam">
          {processSteps.map((step, i) => <li key={step.number} className={`relative border-l border-gold/50 pl-8 lg:border-l-0 lg:border-t lg:pl-0 lg:pr-10 lg:pt-10 ${i < processSteps.length - 1 ? 'pb-12 lg:pb-0' : ''}`} data-id="element-35" data-mp="2ftmr1ib3has3" data-mpi={i}>
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-gold lg:-top-[5px] lg:left-0" aria-hidden="true" data-id="element-36" data-mp="140t4tx5d3plu" />
              <p className="font-serif text-2xl font-medium text-ink/50" data-id="element-37" data-mp="1ctmwyv5wqjh4">{step.number}</p>
              <h3 className="mt-3 font-serif text-[26px] font-medium leading-tight text-navy" data-id="element-38" data-mp="181mw90i0jmjh">
                {step.title}
              </h3>
              <p className="mt-3 max-w-sm leading-relaxed text-ink/70" data-id="element-39" data-mp="1msvqxo0rvy3h">{step.description}</p>
            </li>)}
        </ol>

        <p className="mt-16 max-w-2xl text-sm leading-relaxed text-ink/60" data-id="element-40" data-mp="1vr7cvcqp27pl">
          Every search is shaped around the role and the organization’s requirements, so the scope
          and sequence of our work may vary. Final hiring decisions always rest with the employer.
        </p>
      </div>
    </section>;
}